/**
 * DevExtreme (esm/__internal/ui/multi_view/multi_view.animation.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { fx } from "../../../common/core/animation";
import { move } from "../../../common/core/animation/translator";
export const _translator = {
  move($element, position) {
    move($element, {
      left: position
    });
  }
};
export const animation = {
  moveTo($element, position, duration, completeAction) {
    fx.animate($element.get(0), {
      type: "slide",
      to: {
        left: position
      },
      duration: duration,
      complete: completeAction
    });
  },
  complete($element) {
    fx.stop($element.get(0), true);
  }
};